export default __webpack_public_path__ + "static/media/shop-categories-img05.a6058344.jpg";